/**
 * Project API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProjectStatusModel = 'COMPLETED' | 'ACTIVE' | 'FORECASTED' | 'PLANNED' | 'ON_HOLD' | 'CANCELED';

export const ProjectStatusModel = {
    Completed: 'COMPLETED' as ProjectStatusModel,
    Active: 'ACTIVE' as ProjectStatusModel,
    Forecasted: 'FORECASTED' as ProjectStatusModel,
    Planned: 'PLANNED' as ProjectStatusModel,
    OnHold: 'ON_HOLD' as ProjectStatusModel,
    Canceled: 'CANCELED' as ProjectStatusModel
};

